export enum FilterDataType {
    String = "string",
    Number = "number",
    Boolean = "boolean",
    Date = "date",
}
